import React from 'react';

import loadable from '@common/react/loadable/loadableSettings';
import SimpleLoader from '@common/react/components/UI/Loaders/DatePickerLoader';

const DatepickerEs = loadable(
	() => import(/* webpackChunkName: "CustomDatePickerReact" */ '@common/react/components/base/DatePicker/AdaptiveDatePicker'),
	{
		fallback: <SimpleLoader placeholder="Date..." />,
	},
);

interface DatePickerAltProps {
	value: number;
	onChange: (date: number | null) => void;
	isMobile: boolean;
	placeholder?: string;
	utc?: boolean;
	datePickerProps?: any;
	yearsSelectOptions?: Array<number>;
	useDefaultFormat?: boolean;
	maxToday?: boolean;
	minToday?: boolean;
	selectProps?: any;
}

const LazyDatePickerReact: React.FC<DatePickerAltProps> = (props) => {
	const ref = React.useRef(null);
	const [visible, setVisible] = React.useState(false);

	React.useEffect(() => {
		if (ref.current) {
			const intersectionObserver = new IntersectionObserver((entries) => {
				if (entries[0].isIntersecting) {
					setVisible(true);
				}
			}, {
				rootMargin: '30px',
				threshold: 0.01,
			});

			intersectionObserver.observe(ref.current);
			return () => intersectionObserver.disconnect();
		}
	}, []);

	return visible ? <DatepickerEs {...props} /> : <SimpleLoader placeholder={props.placeholder} ref={ref} />;
};

export default LazyDatePickerReact;
